import styled from "styled-components";


export const HeaderTableSpam = styled.div`

display: flex; 
align-items: center;
justify-content:center;
white-space:nowrap;
cursor:pointer;

`;

export const CotaninerArrow = styled.div`

        display:flex;
        align-items:center;
        flex-direction:column;
        margin-right:2px;

`;